import React from 'react'
import {observer} from 'mobx-react'
import {Box, Text, Flex, Stack, Container} from '../../../vanilla'
import {getImageUrl} from '../utils'
import {SlotComponent} from '../../../types/ui'
import {CategoryTileCmsContent, CategoryTilesCmsContent} from '../../../types/cms'
import {Link} from '../../link'
import {toSlug} from '../../../utils/utils'
import {categoryTileTitle, categoryTileGrid, categoryTileFont, categoryTile, categoryTileImage} from './styles.css'
import {useSelectPromotionTracking} from '../../../analytics/promotion-tracking'
import {createPromoForSelectPromotion} from '../../../analytics/utils.js'
import { CmsImage } from '../cms-image'

export const CategoryTiles: SlotComponent<CategoryTilesCmsContent> = observer(({content, slotIndex}) => {
  return (
    <Container paddingX="0px" data-test-selector="category-tiles-section">
      {content.heading && (
        <Stack align="stretch" marginY="16px">
          <Flex>
            <h2
              style={{
                width: '100%',
                textAlign: 'center',
                borderBottom: '1px solid #d8d8d8',
                lineHeight: '0px',
                margin: '10px 0 20px',
              }}
            >
              <span className={categoryTileTitle} data-test-selector="category-tiles-heading">{content.heading}</span>
            </h2>
          </Flex>
        </Stack>
      )}

      <Box className={categoryTileGrid} display="grid" gap="8px" width="full" data-test-selector="category-tiles-grid">
        {content.tileList?.map((tile, index) => {
          return <CategoryTile key={tile?._meta?.deliveryId} content={tile} slotGroupName={content.slotGroupName} slotIndex={content.slotIndex} index={index + 1} />
        })}
      </Box>
    </Container>
  )
})

export const CategoryTile: SlotComponent<CategoryTileCmsContent> = observer(({content, slotGroupName, slotIndex, index}) => {
  if (!content) {
    return null
  }

    const {backgroundColor, image, imageLink, title} = content

  const selectPromoInfo = {
    content,
    slotGroupName,
    slotPosition: slotIndex,
    index: index
  }

    const promotion = createPromoForSelectPromotion(selectPromoInfo)

    const sendSelectPromotion = useSelectPromotionTracking()

    return (
      <Box
        as={Link}
        href={imageLink}
        style={{backgroundColor: backgroundColor?.theColor}}
        onClickCapture={() => sendSelectPromotion(promotion)}
        className={categoryTile}
        data-test-selector={`category-tile-${toSlug(title || '')}`}
      >
        <Box
          position="absolute"
          bottom="0px"
          right="0px"
          style={{left: 'auto', width: '55%', aspectRatio: '203/165'}}
        >
          <CmsImage
            queryParams={[
              {w: 186, fmt: 'auto', qlt: 'default'},
              {w: 282, fmt: 'auto', qlt: 'default'},
            ]}
            images={image?.images}
            width="full"
            height="auto"
            imageLink={imageLink}
            linkProps={{display: 'block', style: {fontSize: 0}}}
            className={categoryTileImage}
          />
        </Box>

        <Box position="relative" style={{width: '53%', zIndex: 1}}>
          <Text className={categoryTileFont}>{title}</Text>
        </Box>
      </Box>
    )
  }
)
